function toggleNotifyModal(force) {
  const modal = document.getElementById('notify-me-modal');
  if (!modal) return;

  if (typeof force === 'boolean') {
    modal.classList.toggle('active', force);
  } else {
    modal.classList.toggle('active');
  }
}

function bindNotifyButtons() {
  if (document.body.classList.contains('alternative-market')) {
    return;
  }

  document.querySelectorAll('.notify-me-button-overlay').forEach((btn) => {
    if (btn.closest('a[href]')) {
      return;
    }

    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      toggleNotifyModal(true);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  bindNotifyButtons();
  document.getElementById('notify-me-modal-close')?.addEventListener('click', () => toggleNotifyModal(false));
  document.getElementById('notify-me-modal-overlay')?.addEventListener('click', () => toggleNotifyModal(false));
});

document.addEventListener('variant:change', bindNotifyButtons);